import type { Mission } from '../missions.ts'

export const va: Mission = {
  id: "va",
  name: "U.S. Department of Veterans Affairs",
  short: "VA",
  call: "Veterans",
  kind: "department",
  url: "https://www.va.gov/",
  established: 1930,
  palette: {
    primary: "#202a5c",
    secondary: "#005ea2",
    accent: "#face00",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_U.S._Department_of_Veterans_Affairs.svg",
  },
  motif: "eagle",
  mission: {
    text: "To fulfill President Lincoln’s promise to care for those who have served in our nation’s military and for their families, caregivers, and survivors.",
    url: "https://department.va.gov/about/",
  },
  fact: {
    text: "On March 15, 1989, VA became the 14th Department in the President’s Cabinet.",
    url: "https://department.va.gov/about/",
  },
  seal: {
    file: "public/seals/va.png",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_U.S._Department_of_Veterans_Affairs.svg",
  },
  logo: {
    file: "public/logos/va.png",
    source: "https://commons.wikimedia.org/wiki/File:US_Department_of_Veterans_Affairs_logo.svg",
  },
  identifier: {
    about: "https://department.va.gov/about/",
    accessibility: "https://www.va.gov/accessibility-at-va/",
    foia: "https://department.va.gov/foia/",
    noFear: "https://department.va.gov/resolution-management/reports/",
    oig: "https://www.vaoig.gov/",
    performance: "https://department.va.gov/about/va-plans-budget-finances-and-performance/",
    privacy: "https://www.va.gov/privacy-policy/",
  },
  media: {
    photos: [
      {
        file: "/media/va-cleveland.jpg",
        small: "/media/va-cleveland-sm.jpg",
        alt: "The curving, multi-story glass and white facade of the Louis Stokes Cleveland VA Medical Center behind a bed of red flowers.",
        title: "Louis Stokes Cleveland VA Medical Center, Cleveland, Ohio",
        creator: "Veterans Health Administration",
        source: "https://commons.wikimedia.org/wiki/File:Louis_Stokes_Cleveland_VA_Medical_Center_(26875646802).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/va-togus.jpg",
        small: "/media/va-togus-sm.jpg",
        alt: "A red brick VA medical center building with a flagpole and evergreen trees on a wide green lawn.",
        title: "Togus VA Medical Center, Augusta, Maine",
        creator: "Veterans Health Administration",
        source: "https://commons.wikimedia.org/wiki/File:Togus_VA_Medical_Center.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
